import IndustryKpiSearchPage from '@/views/common/industry-kpi-search-page/industry-kpi-search-page.vue';
export const useIndustryKpiSearchModal = () => {
  const {
    openEditor
  } = useComponentModal();
  const showIndustryKpiSearchModal = async (title, {
    kpiType = 1
  } = {}, modalProps = {}) => {
    return openEditor(title, IndustryKpiSearchPage, {
      kpiType
    }, {
      fullscreen: false,
      showMaximize: false,
      showMinimize: false,
      height: '90%',
      width: '90%',
      ...modalProps
    });
  };
  return {
    showIndustryKpiSearchModal
  };
};